export const MODAL_TYPE_NOTIFICATION = 'MODAL_TYPE_NOTIFICATION';
export const MODAL_TYPE_CONFIRMATION = 'MODAL_TYPE_CONFIRMATION';
